import { User, X } from 'lucide-react';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/ui/dialog';
import { ProfileCenterApiKeyPanel } from './profile-center-api-key-panel';

interface ProfileCenterDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  username: string;
  email?: string;
}

export function ProfileCenterDialog({
  open,
  onOpenChange,
  username,
  email,
}: ProfileCenterDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="h-[min(92vh,900px)] w-[calc(100vw-1rem)] max-w-none overflow-visible rounded-xl p-0 shadow-2xl sm:h-[min(88vh,900px)] sm:w-[min(1180px,calc(100vw-2rem))]"
        aria-describedby="profile-center-description"
      >
        <DialogClose className="absolute right-4 top-4 rounded-md p-1 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500">
          <X className="h-4 w-4" />
          <span className="sr-only">关闭</span>
        </DialogClose>
        <DialogHeader className="border-b border-gray-200 px-4 py-4 sm:px-6 sm:py-5">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-50 text-blue-600">
              <User className="h-5 w-5" />
            </div>
            <div>
              <DialogTitle>个人中心</DialogTitle>
              <DialogDescription id="profile-center-description">
                {username}
                {email ? ` · ${email}` : ''}
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>
        <div className="h-[calc(min(92vh,900px)-74px)] overflow-x-auto overflow-y-auto rounded-b-xl bg-white sm:h-[calc(min(88vh,900px)-82px)]">
          <ProfileCenterApiKeyPanel />
        </div>
      </DialogContent>
    </Dialog>
  );
}
